import { ListParams } from "../models/listParams";
import { LayerPublic } from "../models/maps/layerPublic";
import { Organisatie } from "../models/organisatie/organisatie";
import { PagedResult } from "../models/pagedResult";
import { Consortium } from "../models/consortium/consortium";
import { BaseWebService } from "./base.web.service";

export class OrganisatiesWebService extends BaseWebService {

    // Organisaties 

    public async getOrganisaties(listParams: ListParams, zonderGebied: boolean = false) {
        const params = this.createListParams(listParams);
        const headers = await this.getHeadersJson();
        let extraPath = '';
        if (zonderGebied) {
            extraPath = '/zonder-gebied';
        }
        const url = `${this.appConfig.serviceOrganisatiesUrl}/api${extraPath}/organisaties${params}`;
        return this.makeRequest(url, 'GET', headers);
    }

    public async updateOrganisatie(organisatie: Organisatie, zonderGebied: boolean = false) {
        const headers = await this.getHeadersJson();
        const method: 'PUT' | 'PATCH' = organisatie.id ? 'PATCH' : 'PUT';
        let extraPath = '';
        if (zonderGebied) {
            extraPath = '/zonder-gebied';
        }
        const url = `${this.appConfig.serviceOrganisatiesUrl}/api${extraPath}/organisaties${organisatie.id ? `/${organisatie.id}` : ''}`;
        return this.makeRequest(url, method, headers, organisatie, 0, false, true);
    }

    public async updateOrganisatieDisplayName(organisatie: Organisatie, zonderGebied: boolean = false) {
        const headers = await this.getHeadersJson();
        let extraPath = '';
        if (zonderGebied) {
            extraPath = '/zonder-gebied';
        }
        const url = `${this.appConfig.serviceOrganisatiesUrl}/api${extraPath}/organisaties/${organisatie.id}`;
        const body = { displayName: organisatie.displayName };
        return this.makeRequest(url, 'PATCH', headers, body);
    }

    public async deleteOrganisatie(organisationId: string, zonderGebied: boolean = false) {
        const headers = await this.getHeadersJson();
        let extraPath = '';
        if (zonderGebied) {
            extraPath = '/zonder-gebied';
        }
        const url = `${this.appConfig.serviceOrganisatiesUrl}/api${extraPath}/organisaties/${organisationId}`;
        return this.makeRequest(url, 'DELETE', headers, undefined, 0, true); // wrapResponse: true
    }

    // Beheer public layers (Admin) 

    public async getPublicLayers(organizationId: string): Promise<any[]> {
        const headers = await this.getHeadersJson();
        const url = `${this.appConfig.serviceOrganisatiesUrl}/api/layers/${organizationId}`;
        return this.makeRequest(url, 'GET', headers);
    }

    public async getLayersOLD(): Promise<any[]> {
        const headers = await this.getHeadersJson();
        const url = `${this.appConfig.serviceOrganisatiesUrl}/api/layers`;
        return this.makeRequest(url, 'GET', headers);
    }

    public async getLayers(listParams: ListParams): Promise<PagedResult<LayerPublic>> {
        const params = this.createListParams(listParams);
        const headers = await this.getHeadersJson(true);

        const url = `${this.appConfig.serviceOrganisatiesUrl}/api/v1/layers${params}`;
        return this.makeRequest(url, 'GET', headers);
    }

    public async getLayer(layerId: string = ''): Promise<any> {
        const headers = await this.getHeadersJson();
        const url = `${this.appConfig.serviceOrganisatiesUrl}/api/layers/${layerId}`;
        return this.makeRequest(url, 'GET', headers);
    }

    public async postLayer(layer: any) {
        const headers = await this.getHeadersJson();
        const url = `${this.appConfig.serviceOrganisatiesUrl}/api/layers`;
        return this.makeRequest(url, 'POST', headers, layer, 0, true, true);
    }

    public async putLayer(layer: any) {
        const headers = await this.getHeadersJson();
        const url = `${this.appConfig.serviceOrganisatiesUrl}/api/layers/${layer.id}`;
        return this.makeRequest(url, 'PUT', headers, layer, 0, true, true);
    }

    public async deleteLayer(layerId: string) {
        const headers = await this.getHeadersJson();
        const url = `${this.appConfig.serviceOrganisatiesUrl}/api/layers/${layerId}`;
        return this.makeRequest(url, 'DELETE', headers, undefined, 0, true);
    }

    // Consortiums

    public async getConsortiums(listParams: ListParams | null) {
        const headers = await this.getHeadersJson();
        const params = listParams ? this.createListParams(listParams) : '';
        const url = `${this.appConfig.serviceOrganisatiesUrl}/api/v2/consortiums${params}`;

        return this.makeRequest(url, 'GET', headers);
    }

    public async getConsortium(consortiumId: string): Promise<Consortium> {
        const headers = await this.getHeadersJson();
        const url = `${this.appConfig.serviceOrganisatiesUrl}/api/v2/consortiums/${consortiumId}`;

        return this.makeRequest(url, 'GET', headers);
    }

    public async createConsortium(consortium: Consortium) {
        const headers = await this.getHeadersJson();
        const url = `${this.appConfig.serviceOrganisatiesUrl}/api/v2/consortiums`;

        return this.makeRequest(url, 'POST', headers, consortium, 0, true, true);
    }

    public async updateConsortium(consortium: Consortium) {
        const headers = await this.getHeadersJson();
        const url = `${this.appConfig.serviceOrganisatiesUrl}/api/v2/consortiums/${consortium.id}`;

        return this.makeRequest(url, 'PUT', headers, consortium, 0, true, true);
    }

    public async deleteConsortium(consortiumId: string) {
        const headers = await this.getHeadersJson();
        const url = `${this.appConfig.serviceOrganisatiesUrl}/api/v2/consortiums/${consortiumId}`;

        return this.makeRequest(url, 'DELETE', headers, undefined, 0, true);
    }

    public async addOrganizationToConsortium(consortiumId: string, organizationId: string) {
        const headers = await this.getHeadersJson();
        const url = `${this.appConfig.serviceOrganisatiesUrl}/api/v2/consortiums/${consortiumId}/organizations/${organizationId}`;

        return this.makeRequest(url, 'PUT', headers, undefined, 0, true, true);
    }

    public async removeOrganizationFromConsortium(consortiumId: string, organizationId: string) {
        const headers = await this.getHeadersJson();
        const url = `${this.appConfig.serviceOrganisatiesUrl}/api/v2/consortiums/${consortiumId}/organizations/${organizationId}`;

        return this.makeRequest(url, 'DELETE', headers, undefined, 0, true);
    }
}
